module.exports = __webpack_public_path__ + "static/media/stop.04cc21c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/stop.svg
// module id = 690
// module chunks = 0